module.exports = __webpack_public_path__ + "static/assets/4a84bcb11ac2299204cb49f830d52d7f.svg";